import {assert} from 'assert-ts';
import type {CodeListMap} from 'schemaDefinition/types';
import type {CodeListId} from 'services/codelists/types';
import type {ExpressionImportProps} from 'services/metadata/types';
import {getRestrictedExpressionCodelist} from './getRestrictedExpressionCodelist';

export const getRestrictedExpressionCodelists = (
  importProps: ExpressionImportProps,
  outerCodelists: CodeListMap,
  allowAnyExpressionFormat?: boolean,
): CodeListMap => {
  if (importProps === undefined) {
    return outerCodelists;
  }

  const restrictedCodelists = {...outerCodelists};

  Object.keys(restrictedCodelists).forEach(key => {
    const id = key as CodeListId;
    const outer = assert(outerCodelists[id]);
    restrictedCodelists[id] =
      key !== 'EXPRESSION_FORMAT' && !allowAnyExpressionFormat
        ? getRestrictedExpressionCodelist(importProps, outer)
        : outer;
  });

  return restrictedCodelists;
};
